import React from 'react';
import { Link } from 'react-router-dom';
import { OFFICE_ADDRESS, OFFICE_MAPS_URL } from '../../config/office';
import './Footer.css';

const Footer = ({ darkMode }) => {
  return (
    <footer className={`footer ${darkMode ? 'dark' : 'light'}`}>
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-section company-info">
            <div className="footer-logo">
              <Link to="/" className="footer-logo-link">
                <span className="footer-wordmark" aria-label="E-ASY">
                  <span className="footer-wordmark-prefix">E-</span>
                  <span className="footer-wordmark-main">ASY</span>
                </span>
              </Link>
              <p className="company-tagline">
                Consultoría tecnológica en Tenerife
              </p>
            </div>
            <div className="social-links">
              <a href="https://www.linkedin.com/company/insideeasy/" className="social-link" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                <div className="social-icon linkedin">in</div>
              </a>
            </div>
          </div>

          <div className="footer-section services">
            <h4 className="footer-title">Gestión y digitalización</h4>
            <ul className="footer-links">
              <li><Link to="/vulpin" className="footer-link">Vulpin Suite</Link></li>
              <li><Link to="/erp-para-pymes" className="footer-link">ERP para pymes</Link></li>
              <li><Link to="/erp-para-ong" className="footer-link">Software gestión ONG</Link></li>
              <li><Link to="/integracion-sistemas" className="footer-link">Integración de sistemas</Link></li>
              <li><Link to="/consultoria-tecnologica-tenerife" className="footer-link">Consultoría Tenerife</Link></li>
            </ul>
          </div>

          <div className="footer-section services">
            <h4 className="footer-title">Inteligencia artificial</h4>
            <ul className="footer-links">
              <li><Link to="/soluciones-ia" className="footer-link">Soluciones de IA</Link></li>
              <li><Link to="/servicios/bono-ia-plan-ia360" className="footer-link">Bono IA · Plan IA360</Link></li>
              <li><Link to="/cumplimiento-ia" className="footer-link">Cumplimiento IA (Art. 4)</Link></li>
              <li><Link to="/agentes-ia" className="footer-link">Agentes IA</Link></li>
              <li><Link to="/ia-privada" className="footer-link">IA privada</Link></li>
              <li><Link to="/casos" className="footer-link">Casos de referencia</Link></li>
            </ul>
          </div>

          <div className="footer-section services">
            <h4 className="footer-title">Servicios</h4>
            <ul className="footer-links">
              <li><Link to="/vulpin" className="footer-link">Vulpin Suite</Link></li>
              <li><Link to="/servicios/ciberseguridad-cumplimiento" className="footer-link">Ciberseguridad y Cumplimiento</Link></li>
              <li><Link to="/servicios/ia-en-produccion" className="footer-link">IA en Producción</Link></li>
              <li><Link to="/servicios/desarrollo-web-ecommerce" className="footer-link">Desarrollo Web y E-commerce</Link></li>
              <li><Link to="/servicios/consultoria-microsoft-azure" className="footer-link">Consultoría Microsoft / Azure / Google Workspace</Link></li>
              <li><Link to="/servicios/ingenieria-a-cuota" className="footer-link">Ingeniería a cuota</Link></li>
            </ul>
          </div>

          <div className="footer-section company">
            <h4 className="footer-title">Empresa</h4>
            <ul className="footer-links">
              <li><Link to="/sobre-nosotros" className="footer-link">Sobre nosotros</Link></li>
              <li><Link to="/donde-trabajamos" className="footer-link">Dónde trabajamos</Link></li>
              <li><Link to="/capacidades" className="footer-link">Capacidades</Link></li>
              <li><Link to="/blog" className="footer-link">Blog</Link></li>
              <li><Link to="/empleo" className="footer-link">Trabaja con nosotros</Link></li>
              <li><Link to="/contacto" className="footer-link">Contacto</Link></li>
            </ul>
          </div>

          <div className="footer-section contact">
            <h4 className="footer-title">Contacto</h4>
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div className="contact-details">
                  <span className="contact-label">Oficina</span>
                  <a className="contact-value" href={OFFICE_MAPS_URL} target="_blank" rel="noopener noreferrer">
                    {OFFICE_ADDRESS}
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div className="contact-details">
                  <span className="contact-label">Teléfono</span>
                  <span className="contact-value">+34 822 68 50 12</span>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">✉️</div>
                <div className="contact-details">
                  <span className="contact-label">Email</span>
                  <span className="contact-value">comercial@e-asy.es</span>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">🕒</div>
                <div className="contact-details">
                  <span className="contact-label">Horario</span>
                  <span className="contact-value">9:00 - 17:00</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <div className="legal-links">
              <Link to="/politica-privacidad" className="legal-link">Política de Privacidad</Link>
              <Link to="/aviso-legal" className="legal-link">Términos de Servicio</Link>
              <Link to="/politica-cookies" className="legal-link">Cookies</Link>
              <Link to="/aviso-legal" className="legal-link">Aviso Legal</Link>
            </div>
            <div className="copyright">
              <p>© 2026 E-ASY. Todos los derechos reservados.</p>
            </div>
          </div>
          {/* Newsletter section hidden until service is enabled
          <div className="footer-newsletter">
            <div className="newsletter-content">
              <h5 className="newsletter-title">Mantente informado</h5>
              <p className="newsletter-description">Recibe las últimas noticias y casos de éxito</p>
              <div className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Tu email" 
                  className="newsletter-input"
                />
                <button className="newsletter-button">
                  Suscribirse
                </button>
              </div>
            </div>
          </div>
          */}
        </div>
      </div>
    </footer>
  );
};

export default Footer; 